export default __webpack_public_path__ + "static/media/kota-background.fae3b790.jpg";